import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { ClosableModal, ModalService } from '../../../shared/modules/modal';
import { NotificationService } from '../../../shared/services';

import { TranslationConstants } from '../../../shared/constants';

import { EconomicAnalysis } from '../../../shared/models/economic-analysis';
import { EditEconomicsAnalysisModalPayload } from '../../../shared/models';

@Component({
  selector: 'edit-economics-analysis-modal',
  templateUrl: './edit-economics-analysis-modal.component.html',
})
export class EditEconomicsAnalysisModalComponent extends ClosableModal implements OnInit, OnDestroy {
  data: EditEconomicsAnalysisModalPayload;
  economicAnalysis: EconomicAnalysis = new EconomicAnalysis();

  private subscriptions = [];
  responseErrors: string[] = [];

  constructor(
    protected modalService: ModalService,
    private _notificationsService: NotificationService
  ) {
    super(modalService);

  }

  ngOnInit(): void {
    this.economicAnalysis = this.data.economicAnalysis;
    this.listenForErrorMessages();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => { subscription.unsubscribe(); });
  }

  // override
  close(): void {
    this.closeAllModals();
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this.closeAllModals();
  }

  private listenForErrorMessages(): void {
    // this.subscriptions.push(
    //   this._notificationsService.notification$.subscribe((message) => {
    //     this.handleErrors(message);
    //   })
    // );
  }

  protected handleErrors(res: HttpErrorResponse): void {
    if (res.status === 400) {
      this.responseErrors.push(res.error.errors.global);
    } else {
      this.responseErrors.push(TranslationConstants.GLOBAL_SERVER_ERROR);
    }
  }
}
